module.exports = __webpack_public_path__ + "img/19.16539246.jpg";